import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const editTestCase = async ({ data }) => {
  const user = getUserDetails();
  const response = await axios.put(
    `${API_BACKEND_URL}/updateApiInfo?companyId=${user.companyid}`,
    data,
  );
  return response.data;
};

export const useEditTestCase = (options = {}) => {
  return useMutation({
    mutationFn: editTestCase,
    ...options,
  });
};

const deleteTestCase = async ({ testCaseId }) => {
  const user = getUserDetails();
  const response = await axios.delete(
    `${API_BACKEND_URL}/testcase/deleteTC?companyId=${user.companyid}&testCaseId=${testCaseId}`,
  );
  return response.data;
};

export const useDeleteTestCase = (options = {}) => {
  return useMutation({
    mutationFn: deleteTestCase,
    ...options,
  });
};
